import { FetchUtil } from "../util/FetchUtil";
import { IHealioStoreEndpoint } from "../models/HealioBigComm/IHealioStoreEndpoint";
import { IHealioStoreAddProductToCartResponse } from "../models/HealioBigComm/IHealioStoreAddProductToCartResponse";
import { IHealioStoreCartRequest } from "../models/HealioBigComm/IHealioStoreCartRequest";
import { IHealioStoreProductsByCategoryResponse } from "../models/HealioBigComm/IHealioStoreProductsByCategoryResponse";
import { StringUtil } from "../util/StringUtil";

export class HealioStoreService {
  constructor(private readonly _endpoint: IHealioStoreEndpoint) {
  }

  public async productsByCategoryId(categoryId: string): Promise<IHealioStoreProductsByCategoryResponse.RootObject | null> {
    const endpoint = this._endpoint.productsByCategoryId;
    if (!endpoint) {
      console.error("Could not resolve endpoint for ProductsByCategoryId.");

      return null;
    }

    const queryString = categoryId ? [
      "categoryid=" + encodeURIComponent(categoryId),
    ].filter(Boolean).join("&") : null;

    const query = queryString ? "?" + queryString : null;

    const url =
      (StringUtil.supplant(endpoint.url, { query }) || "")
        .replace(/\{(?:query)\}/g, "");

    let response: IHealioStoreProductsByCategoryResponse.RootObject | null = null;
    try {
      const result = await FetchUtil
        .sendMessage({ method: endpoint.method, url }, null);
      response = result as IHealioStoreProductsByCategoryResponse.RootObject;
    } catch {
      console.log("Error in getting ProductsByCategoryId");
    }

    return response;

  }

  public async addProductToCart(cartRequest: IHealioStoreCartRequest): Promise<IHealioStoreAddProductToCartResponse.RootObject | null> {
    const endpoint = this._endpoint.addProductToCart;
    if (!endpoint) {
      console.error("Could not resolve endpoint for addProductToCart.");

      return null;
    }


    const url = endpoint.url;

    let response: IHealioStoreAddProductToCartResponse.RootObject | null = null;
    try {
      const result = await FetchUtil
        .sendMessage({ method: endpoint.method, url }, cartRequest);
      response = result as IHealioStoreAddProductToCartResponse.RootObject;
    } catch {
      console.error("Error in addProductToCart");
    }

    return response;

  }

}
